import isPropValid from "@emotion/is-prop-valid";
import { IStyleSheetContext } from "styled-components";

import { ENV_EVALA_PRODUCTION, ENV_EVALA_VERSION, LOGIN_PAGE_SUBDOMAIN, SYSTEM_CONFIG_URL } from "./constants";
import memoize from "./utils/memoize";

interface ISystemConfiguration {
    DisableSubdomains?: boolean;
    Domain?: string;
    InboxEmailDomain?: string;
}

export const getSystemConfig = memoize(async (): Promise<ISystemConfiguration> => {
    const result = await fetch(SYSTEM_CONFIG_URL, { method: "GET" });
    if (!result.ok) {
        // todo: what in this case...
        return {};
    }
    return await result.json();
});

/** This will only return true in actual production, not on nightly.
 * It differs from process.env.NODE_ENV which returns "development" when running dev server and "production" on build (nightly) */
export const isEvalaProduction = (): boolean => {
    return !!process.env[ENV_EVALA_PRODUCTION];
};

export const isLoginAppSubdomain = (): boolean => {
    const { host } = window.location;
    return host.startsWith(`${LOGIN_PAGE_SUBDOMAIN}.`);
};

export const EvalaDevelVersion = "devel";

/** Returns current Evala version in production, "devel" in development. */
export const getEvalaVersion = (): string => {
    return process.env[ENV_EVALA_VERSION] || EvalaDevelVersion;
};

// This implements the default behavior from styled-components v5
export const shouldForwardProp: IStyleSheetContext['shouldForwardProp'] = (propName, target) => {
    if (typeof target === "string") {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return isPropValid(propName);
    }
    // For other elements, forward all props
    return true;
};

export function isSafari() {
    const ua = window.navigator.userAgent;
    return /^((?!chrome|android|crios|fxios|edgios|edg).)*safari/i.test(ua);
}

export function isFirefox() {
    const ua = navigator.userAgent;
    return /firefox/i.test(ua) || /fxios/i.test(ua);
}